import axios from 'axios'
import * as Constants from '../_config/app'
import { enqueueSnackbar } from 'notistack'
import { trans } from '@/_providers/Translation'

const Api = axios.create({
    baseURL: Constants.App.api
})

Api.interceptors.request.use(config => {

    const token = localStorage.getItem('auth') ? (JSON.parse(localStorage.getItem('auth')).data.access_token) : ''

    config.params = config.params || {}

    if (token) {
        config.headers['Authorization'] = `Bearer ${token}`
    }

    return config
})

const POST_SUCCESS_ENDPOINTS = [
    '/edit',
    '/add',
    '/delete',
    '/create',
    'reservations/reclamation',
    'reservations/continue',
    'reservations/replicate',
    'reservations/send-sms-details',
    'reservations/send-confirmation',
    'text-messages/send-now',
    'reservations/files',
    'reservations/uploaded-files/delete',
]

Api.interceptors.response.use(response => {
    if (response.config.method === 'post' && POST_SUCCESS_ENDPOINTS.some(endpoint => response.config.url?.includes(endpoint))) {
        enqueueSnackbar(trans('messages.success'), {
            variant: 'success',
        })
    }
    return response
}, (error) => {
    // console.log(error.response);

    if (error.response && error.response.status) {
        if (error.response.status === 401) {
            if (window.location.pathname.indexOf('login') === -1) {

                let storage = localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : null

                let redirectUrl = '/login/partners'

                if (storage?.data?.user?.is_administrator) {
                    redirectUrl = '/login/admin'
                }

                localStorage.clear()

                window.location = redirectUrl + '?redirect=' + encodeURIComponent(window.location.pathname + window.location.search)
            }
        }
    }

    return Promise.reject(error)
})

export default Api